/**
 * @Author: v_jppjpeng
 * @Date: 2025-04-11 17:11:13
 * @Explain: 用户旅程
 */

export default {
  'USER.JOURNEY.LIST.TITLE': '旅程列表',
  'USER.JOURNEY.LIST.CONCAT.SENT': '联系人发送数量',
  'USER.JOURNEY.LIST.CONCAT.START': '加入旅程',
  'USER.JOURNEY.LIST.CONCAT.PROGRESS': '旅程中',
  'USER.JOURNEY.LIST.CONCAT.FINISH': '完成旅程',
  'USER.JOURNEY.LIST.CREATE': '开始创建',
  'USER.JOURNEY.LIST.TIP': '玩家旅程：让沟通自动发生',
  'USER.JOURNEY.LIST.DES':
    '设置自动发件旅程，当特定来源的联系人加入SmartLink联系人列表时，向他们发送欢迎电子邮件，给他们留下良好的第一印象。',
  'USER.JOURNEY.LIST.STATUS.ONGOING': '进行中',
  'USER.JOURNEY.LIST.STATUS.DRAFT': '草稿',
  'USER.JOURNEY.LIST.STATUS.NODE.ERROR': '进行中-节点异常',
  'USER.JOURNEY.LIST.STATUS.SUSPENDED.NODE.ERROR': '暂停中-节点异常',
  'USER.JOURNEY.LIST.STATUS.SUSPENDED': '暂停中',
  'USER.JOURNEY.LIST.STATUS.TERMINATED': '已终止',
  'USER.JOURNEY.LIST.DEL.TITLE': '确定删除旅程节点？',
  'USER.JOURNEY.LIST.DEL.DES': '删除后，节点信息不可恢复。',
  'USER.JOURNEY.LIST.CREATE.USER.JOURNEY': '创建玩家旅程',

  'USER.JOURNEY.ADD.SOURCE.BOX.TIP': '添加旅程起点',
  'USER.JOURNEY.ADD.SOURCE.BOX.TITLE': '选择旅程起点',
  'USER.JOURNEY.ADD.SOURCE.BOX.API.TIP': 'API',
  'USER.JOURNEY.ADD.SOURCE.BOX.API.DES': '通过API添加到项目',
  'USER.JOURNEY.ADD.SOURCE.BOX.FORM.TIP': 'Form',
  'USER.JOURNEY.ADD.SOURCE.BOX.FORM.DES': '通过表单提交添加到项目',
  'USER.JOURNEY.ADD.SOURCE.BOX.TAG.TIP': 'Tag',
  'USER.JOURNEY.ADD.SOURCE.BOX.TAG.DES': '打上标签',

  // api
  'USER.JOURNEY.ADD.SOURCE.DRAW.API.TITLE': '选择添加联系人的API名称',
  'USER.JOURNEY.ADD.SOURCE.DRAW.API.CONTENT.TIP': '需订阅确认时的进入策略',
  'USER.JOURNEY.ADD.SOURCE.DRAW.API.TYPE.1': '仅在用户完成订阅确认后进入旅程。',
  'USER.JOURNEY.ADD.SOURCE.DRAW.API.TYPE.1.DES':
    '当该来源启用了订阅确认，联系人需手动完成确认（如点击确认链接）后，才会进入旅程。系统或其他方式修改状态不会触发旅程。',
  'USER.JOURNEY.ADD.SOURCE.DRAW.API.TYPE.2':
    '不区分订阅状态，联系人添加后立即进入旅程。',
  'USER.JOURNEY.ADD.SOURCE.DRAW.API.TYPE.2.DES':
    '联系人在被添加后，将不考虑其订阅状态，<b>无论是否确认订阅</b>，都将直接进入旅程。请确保此用法符合你的渠道要求和合规政策。',
  'USER.JOURNEY.ADD.SOURCE.DRAW.API.SELECT': '选择一个API',
  'USER.JOURNEY.ADD.SOURCE.DRAW.API.SEARCH': '查询API',
  // form
  'USER.JOURNEY.ADD.SOURCE.DRAW.FORM.TITLE': '选择添加联系人的表单名称',
  'USER.JOURNEY.ADD.SOURCE.DRAW.FORM.SELECT': '选择一个表单',
  'USER.JOURNEY.ADD.SOURCE.DRAW.FORM.SEARCH': '查询表单',
  // tag
  'USER.JOURNEY.ADD.SOURCE.DRAW.TAG.TITLE': '选择联系人标记哪个标签后进入旅程',
  'USER.JOURNEY.ADD.SOURCE.DRAW.TAG.SELECT': '选择一个标签',
  'USER.JOURNEY.ADD.SOURCE.DRAW.TAG.SEARCH': '查询标签',

  // 创建、编辑
  'USER.JOURNEY.EDIT.SAVE.QUIT': '保存并退出',
  'USER.JOURNEY.EDIT.SAVE.ACTIVATE': '保存并激活旅程',
  'USER.JOURNEY.SELECT.DEFAULT.TEMPLATE': '默认模板',
  'USER.JOURNEY.SELECT.MARKETING.TEMPLATE': '营销邮件模板',
  'USER.JOURNEY.EDIT.NODE.DELETE.TITLE': '确定删除旅程节点？',
  'USER.JOURNEY.EDIT.NODE.DELETE.CONTENT': '删除后，节点信息不可恢复。',
  'USER.JOURNEY.EDIT.SOURCE.NODE.DELETE.TITLE': ' 确定删除旅程起点？',
  'USER.JOURNEY.EDIT.SOURCE.NODE.DELETE.CONTENT': '删除后，节点信息不可恢复。',
  'USER.JOURNEY.EDIT.NODE.ACTIVE.TITLE': '确认激活旅程么？',
  'USER.JOURNEY.EDIT.NODE.ACTIVE.CONTENT':
    '旅程激活后，会自动执行节点设置，请检查旅程流程及节点设置是否符合预期。',
  'USER.JOURNEY.EDIT.ADD.SOURCE': '新增来源',
  'USER.JOURNEY.EDIT.ADD.JOURNEY.POINT': '增加旅程节点',
  'USER.JOURNEY.EDIT.SELECT.JOURNEY.POINT': '选择要增加的节点',
  'USER.JOURNEY.EDIT.SELECT.CONDITION': '规则',
  'USER.JOURNEY.EDIT.SELECT.WAIT.TIME': '等待一段时间',
  'USER.JOURNEY.EDIT.SELECT.IF.ELSE': '条件判断',
  'USER.JOURNEY.EDIT.SELECT.IF.ELSE.NAMED.TIPS': '条件已设置',
  'USER.JOURNEY.EDIT.SELECT.IF.ELSE.UNAMED.TIPS': '条件未设置',
  'USER.JOURNEY.EDIT.SELECT.ACTION': '动作',
  'USER.JOURNEY.EDIT.SELECT.SEND.MAIL': '发送邮件',
  'USER.JOURNEY.EDIT.SELECT.SEND.TEST.MAIL': '发送测试邮件',
  'USER.JOURNEY.UNNAMED.NODE': '未命名节点',
  'USER.JOURNEY.EDIT.EMAIL.HAVE.SET': '发送邮件设置成功',
  'USER.JOURNEY.EDIT.SET.UP.SUCCESS': '设置成功',
  'USER.JOURNEY.EDIT.EXIT': '退出',
  'USER.JOURNEY.WAIT.NUM.REG.TIPS': '请输入1-100范围内的数字',
  'USER.JOURNEY.JOURNEY.SOURCE.CITED.ERROR': '来源已被引用',
  'USER.JOURNEY.PLACEHOLDER.ERROR.1': '资源码缺失，发送已暂停。',
  'USER.JOURNEY.PLACEHOLDER.ERROR.2': '资源码即将耗尽',
  'USER.JOURNEY.NODE.ERROR.1': '请检查旅程节点是否填写完整',
  'USER.JOURNEY.NODE.ERROR.2': '请检查节点信息',
  'USER.JOURNEY.NODE.ERROR.3':
    '激活失败，缺失内置链接。请检查{language}下邮件模板',
  'USER.JOURNEY.NODE.ERROR.4': '请检查发送邮件节点信息，存在重复名称',
  'USER.JOURNEY.NODE.DELETE.TIPS': '删除后，节点信息不可恢复。',
  'USER.JOURNEY.NODE.DELETE.LABEL': '如何处理此节点下路径？',
  'USER.JOURNEY.NODE.DELETE.KEEP.YES': '保留"是"路径',
  'USER.JOURNEY.NODE.DELETE.KEEP.NO': '保留"否"路径',
  'USER.JOURNEY.NODE.DELETE.BOTH.PATH': '删除所有路径',
  'USER.JOURNEY.NODE.SEND.EMAIL.USED.TIPS': '条件判断节点使用中',
  'USER.JOURNEY.NODE.DELETE.SUCCEEDED': '删除成功',
  'USER.JOURNEY.NODE.NAME.DUPLICATED.ERROR': '名称重复，请修改',
  'USER.JOURNEY.EDIT.NOT.ALLOW': '旅程被其他用户编辑',

  // if/else
  'USER.JOURNEY.IF.ELSE.SETTING.TITLE': '创建分层规则以判断联系人是否满足',
  'USER.JOURNEY.IF.ELSE.DETAILS.TITLE': '条件判断详情',
  'USER.JOURNEY.SEGMENT.RULES': '分层规则',
  // 旅程统计
  'USER.JOURNEY.POINT.STATISTICS': '旅程节点统计',

  // Wait for a trigger
  'USER.JOURNEY.TRIGGER.TITLE': '等待触发',
  'USER.JOURNEY.TESTER.FILED': '测试玩家字段',
  'USER.JOURNEY.TRIGGER.TITLE.DETAILS': '等待触发详情',

  // 设置时间限制
  'USER.JOURNEY.TIME.LIMIT.TITLE': '设定时间限制',
  'USER.JOURNEY.TIME.LIMIT.DESC':
    '若联系人在该时间限制内未满足条件，他们将进入下一个旅程节点。',
  'USER.JOURNEY.TIME.LIMIT.WAIT.FOR.LABEL': '等待',

  // 重启弹框文案
  'USER.JOURNEY.RESTART.TITLE': '旅程重启确认',
  'USER.JOURNEY.RESTART.TIP.TIME.HOUR':
    '旅程已暂停：<span class="mark">{hour}</span>小时',
  'USER.JOURNEY.RESTART.TIP.TIME.DAY.1':
    '旅程已暂停：<span class="mark">{day}</span>天',
  'USER.JOURNEY.RESTART.TIP.TIME.DAY.2':
    '旅程已暂停：<span class="mark">{day}</span>天<span class="mark">{hour}</span>小时',
  'USER.JOURNEY.RESTART.TIP.CONCAT':
    '堆积人数累计：<span class="mark">{num}</span>',
  'USER.JOURNEY.RESTART.DES': '重启后，可选择让堆积联系人加入旅程。',
  'USER.JOURNEY.RESTART.SWITCH.TIP': '加入旅程',

  'USER.JOURNEY.DETAIL.OPT.DRAWER.TITLE': '二次确认订阅 : 设置的二次订阅规则',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.TITLE.SINGLE': '二次确认订阅 : 单次确认加入',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.TITLE.DOUBLE_PARTICULAR':
    '二次确认订阅 : 特定地区玩家双重确认加入',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.TITLE.DOUBLE_ALL':
    '二次确认订阅 : 所有地区玩家双重确认加入',
  'USER.JOURNEY.DETAIL.OPT.IN.TIPS1': '二次确认节点仅对V3及以下版本接口生效；',
  'USER.JOURNEY.DETAIL.OPT.IN.TIPS2':
    'API-key设置页面的二次确认邮件配置对V4 版本接口生效；',
  'USER.JOURNEY.DETAIL.OPT.IN.TIPS3':
    '表单的二次确认配置转移到表单设置页，此节点对表单不生效。',

  'USER.JOURNEY.DETAIL.VAR.CONFIRM.TITLE': '节点重启确认',
  'USER.JOURNEY.DETAIL.VAR.CONFIRM.TIP1.1':
    '节点已暂停： <span class="mark">{hour}</span> 小时',
  'USER.JOURNEY.DETAIL.VAR.CONFIRM.TIP1.2':
    '节点已暂停：<span class="mark">{day}</span>  天',
  'USER.JOURNEY.DETAIL.VAR.CONFIRM.TIP1.3':
    '节点已暂停：<span class="mark">{day}</span>  天 <span class="mark">{hour}</span>  小时',
  'USER.JOURNEY.DETAIL.VAR.CONFIRM.TIP2':
    '堆积人数累计：<span class="mark">{num}</span> 个联系人',
  'USER.JOURNEY.DETAIL.VAR.CONFIRM.TIP3': '重启后，可补发堆积联系人。',
  'USER.JOURNEY.DETAIL.VAR.CONFIRM.TIP4': '补发',

  'USER.JOURNEY.DETAIL.OPT.DRAWER.RESTART': '重启',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.RESTART.DIS.TIP': '请先上传资源码再重启节点',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.VAR.TIP': '资源码缺失，发送已暂停。',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.VAR.NORMAL.1':
    '资源码已添加，可以重新启动该点',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.VAR.NORMAL.2': '点击右侧按钮，重启该点',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.VAR.WARN.HOUR.TIP1':
    '节点异常：<span class="mark">{hour} 小时</span>',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.VAR.WARN.HOUR.TIP2':
    '节点异常：<span class="mark">{day} 天</span>',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.VAR.WARN.HOUR.TIP3':
    '节点异常：<span class="mark">{day} 天</span><span class="mark">{hour} 小时</span>',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.VAR.WARN.DAY.TIP':
    '节点异常：<span class="mark">{day} 天</span> <span class="mark">{hour} 小时</span>',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.CONCAT.WARN.TIP':
    '堆积人数累计： <span class="mark">{num} 联系人</span>',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.VAR.CONTENT.TIP':
    '点击资源码名称上传变量值：',
  'USER.JOURNEY.DETAIL.OPT.PERF.TITLE': '表现',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.TITLE': '联系人来源',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.ALL': '全部',
  'USER.JOURNEY.DETAIL.OPT.TOTAL.CONTACTS': '表单提交总人次',
  'USER.JOURNEY.DETAIL.OPT.NOT.SEND': '无需发送',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.SENDED': '已发送',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.DELIVER': '已送达/送达率',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.OPENED': '已打开/打开率',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.CLICKED': '已点击/点击率',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.CONFIRM': '已确认/确认率',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.UNSUB': '取消订阅/取消订阅率',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.NOT.SEND': '无需发送 <b>{notSend}</b> ',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.FAIL.SEND': '发送失败 <b>{failSend}</b>',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.FAIL.SEND.INFO':
    '积压: <b>{sendBlock}</b> <br>反弹: <b>{sendBounce}</b>',
  'USER.JOURNEY.DETAIL.OPT.UNDELIVERED': '未送达 <b>{undelivered}</b>',
  'USER.JOURNEY.DETAIL.OPT.NO.SEND.TIPS1': '联系人加入时无需发送',
  'USER.JOURNEY.DETAIL.OPT.NO.SEND.TIPS2': '联系人地区无需发送',
  'USER.JOURNEY.DETAIL.OPT.REPEAT.COMMIT.TIPS': '一小时内重复提交',
  'USER.JOURNEY.DETAIL.OPT.HARD.REBOUND': '硬反弹',
  'USER.JOURNEY.DETAIL.OPT.QUEUE': '队列积压',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.EMAIL.FROM': '来源 :',

  // 旅程设置
  'USER.JOURNEY.SETTING.TITLE': '旅程设置',
  'USER.JOURNEY.SETTING.REENTRY.0': '联系人不可重复进入旅程',
  'USER.JOURNEY.SETTING.REENTRY.1': '联系人可以重复进入旅程',
  'USER.JOURNEY.SETTING.REENTRY.REENTRY.UNIT.LABEL':
    '允许联系人在离开旅程后多久再次进入旅程',
  'USER.JOURNEY.SETTING.REENTRY.UNIT.MINUTE': '分钟',

  //  表单未激活
  'USER.JOURNEY.SOURCE.FORM.NOT.ACTIVE':
    '表单 <span class="mark">{name}</span> 未激活，提交此表单的联系人无法进入旅程。',

  // 节点流量控制
  'USER.JOURNEY.FREQUENCY.CONTROL.SWITCH.LABEL': '启用发送速率限制',
  'USER.JOURNEY.FREQUENCY.CONTROL.SWITCH.BUBBLE.DESC':
    '让邮件陆续送达，避免集中触达，适合需要节奏控制的投放场景。',
  'USER.JOURNEY.FREQUENCY.CONTROL.SEND.UP.TO.LABEL': '最多发送',
  'USER.JOURNEY.FREQUENCY.CONTROL.SEND.UP.TO.AFTER': '个订阅用户',
  'USER.JOURNEY.FREQUENCY.CONTROL.SUBSCRIBERS.PER.LABEL': '每',
  'USER.JOURNEY.FREQUENCY.CONTROL.SPACED.LABEL': '发送间隔',
  'USER.JOURNEY.FREQUENCY.CONTROL.APART.AFTER': '',
  'USER.JOURNEY.FREQUENCY.CONTROL.SENDING.INTERVAL.OPTS.NOT.SET': '不设置',
  'USER.JOURNEY.FREQUENCY.CONTROL.SENDING.INTERVAL.OPTS.NOT.SET.TIPS':
    '按系统默认速度发送',
  'USER.JOURNEY.FREQUENCY.CONTROL.SENDING.INTERVAL.OPTS.1': '1分钟',
  'USER.JOURNEY.FREQUENCY.CONTROL.SENDING.INTERVAL.OPTS.2': '5分钟',
  'USER.JOURNEY.FREQUENCY.CONTROL.SENDING.INTERVAL.OPTS.3': '30分钟',
  'USER.JOURNEY.FREQUENCY.CONTROL.SENDING.INTERVAL.OPTS.4': '1小时',
  'USER.JOURNEY.FREQUENCY.CONTROL.SENDING.INTERVAL.OPTS.5': '3小时',

  'USER.JOURNEY.TEST.EMAIL.LABEL': '多语种邮件发至同一邮箱',
  'USER.JOURNEY.TEST.PLACEHOLDER.LABEL': '设置资源码替换值',

  // 条件节点缩略提示
  'USER.JOURNEY.CONDITION.NODE.TRIGGER.BUTTON': '条件',
  'USER.JOURNEY.CONDITION.NODE.TYPE.TAG': '标签',
  'USER.JOURNEY.CONDITION.NODE.TYPE.SOURCE': '来源',
  'USER.JOURNEY.CONDITION.NODE.TYPE.SOURCE.JOIN.TIME': '加入时间',
  'USER.JOURNEY.CONDITION.NODE.TYPE.SOURCE.JOIN.RANGE': '范围',
  'USER.JOURNEY.CONDITION.NODE.TYPE.SOURCE.JOIN.EQUAL': '等于',
  'USER.JOURNEY.CONDITION.NODE.TYPE.SOURCE.JOIN.NOT.EQUAL': '不等于',
  'USER.JOURNEY.CONDITION.NODE.TYPE.SOURCE.JOIN.TIME.DAY': '{day}天',
  'USER.JOURNEY.CONDITION.NODE.TYPE.SOURCE.JOIN.CHANNEL': '加入渠道',
  'USER.JOURNEY.CONDITION.NODE.TYPE.REGION': '区域',
  'USER.JOURNEY.CONDITION.NODE.TYPE.LANG': '区域',
  'USER.JOURNEY.CONDITION.NODE.TYPE.ADD.TIME': '添加时间',
  'USER.JOURNEY.CONDITION.NODE.TYPE.PREFERENCE': '偏好',
  'USER.JOURNEY.CONDITION.NODE.TYPE.FIELD.DATE': '时间类型',
  'USER.JOURNEY.CONDITION.NODE.TYPE.FIELD.TEXT': '文本类型',
  'USER.JOURNEY.CONDITION.NODE.TYPE.FIELD.NUMBER': '数字类型',
  'USER.JOURNEY.CONDITION.NODE.TYPE.FIELD.OPTIONS': '选项类型',
  'USER.JOURNEY.CONDITION.NODE.TYPE.FIELD.INCLUDE.NONE': '包含空值',
  'USER.JOURNEY.CONDITION.NODE.TYPE.FIELD.NOT.INCLUDE.NONE': '排除空值',
  'USER.JOURNEY.CONDITION.NODE.TYPE.CONCAT.JOIN.CLICK': '点击',
  'USER.JOURNEY.CONDITION.NODE.TYPE.CONCAT.JOIN.OPEN': '打开',
  'USER.JOURNEY.CONDITION.NODE.TYPE.CONCAT.JOIN.UNCLICK': '未点击',
  'USER.JOURNEY.CONDITION.NODE.TYPE.CONCAT.JOIN.UNOPEN': '未打开',
  'USER.JOURNEY.CONDITION.NODE.TYPE.CONCAT.JOIN.SATISFIED.EVALUATION':
    '满意度评价',
  'USER.JOURNEY.CONDITION.NODE.TYPE.CONCAT.JOIN.SATISFIED.RATE': '满意度结果',
  'USER.JOURNEY.CONDITION.NODE.TYPE.CAMPAIGN': '活动',
  'USER.JOURNEY.CONDITION.NODE.TYPE.EMAIL.NODE': '旅程节点',

  // 旅程提示
  'USER.JOURNEY.TEST.PLAYER.TIP': '邀请旅程',
  'USER.JOURNEY.TEST.PLAYER.CONTENT.1': '1. 仅受邀的测试者立即进入旅程，状态由“等待”变更为“已邀请”。',
  'USER.JOURNEY.TEST.PLAYER.CONTENT.2': '2. 仅在测试者完成邀请流程后，其状态才会变更为“已接受”。',
  'USER.JOURNEY.TEST.PLAYER.CONTENT.3': '3. 您可以自定义测试者接受邀请的整个流程，以及定义何种情况下（如特定操作）将其状态从“已邀请”更新为“已接受”。',
  'USER.JOURNEY.TEST.PLAYER.DISABLE.ADD':'不支持添加。',
  'USER.JOURNEY.TEST.PLAYER.DISABLE.DEL':'不支持删除。',
  'USER.JOURNEY.TEST.PLAYER.SOURCE.TIP':'被邀请联系人',
  'USER.JOURNEY.TEST.PLAYER.EMAIL.TIP':'邀请邮件',
  'USER.JOURNEY.TEST.PLAYER.CONDITION.EMAIL.TIP':'资源码邮件',
  'USER.JOURNEY.NODE.ERROR.NAME.SAME':'节点名称重复: {name}',
};
